// ----------------------------------------------------------------------------
// Template: Blog
// ----------------------------------------------------------------------------
//
// ----------------------------------------------------------------------------

// -------------------------------------
// Dependencies
// -------------------------------------

// Scripts
import 'sections/header/header';
import 'snippets/pagination/pagination';
import 'sections/page-hero/page-hero';
import 'sections/main-blog/main-blog';
import 'sections/blog-posts/blog-posts';
import 'sections/footer/footer';